var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLabs2 = function SvgLabs2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52.877,
    height: 40.213,
    viewBox: "0 0 52.877 40.213",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_medical_files_1061796",
    "data-name": "noun_medical files_1061796",
    transform: "translate(-15.955 -24.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10652",
    "data-name": "Path 10652",
    d: "M38.429,61.1a.878.878,0,0,0,.233.271,1.078,1.078,0,0,0,.326.178,1.212,1.212,0,0,0,.393.064h3.1l.026,2.5a.671.671,0,0,0,.083.311.817.817,0,0,0,.212.252,1.048,1.048,0,0,0,.315.168,1.191,1.191,0,0,0,.382.064H45.24a1.2,1.2,0,0,0,.382-.064,1.048,1.048,0,0,0,.315-.168.818.818,0,0,0,.212-.252.671.671,0,0,0,.083-.311l.026-2.5h3.1a1.212,1.212,0,0,0,.393-.064,1.075,1.075,0,0,0,.279-.178.879.879,0,0,0,.227-.262.714.714,0,0,0,.088-.321l.047-1.48a.707.707,0,0,0-.067-.331.828.828,0,0,0-.212-.271,1.045,1.045,0,0,0-.32-.183,1.174,1.174,0,0,0-.4-.069H46.268l.026-2.66a.755.755,0,0,0-.078-.34A.872.872,0,0,0,46,55.177a1.045,1.045,0,0,0-.331-.187,1.19,1.19,0,0,0-.4-.069h-1.84a1.19,1.19,0,0,0-.4.069,1.045,1.045,0,0,0-.331.187.877.877,0,0,0-.217.281.759.759,0,0,0-.078.34l.026,2.66H39.281a1.168,1.168,0,0,0-.393.069,1.007,1.007,0,0,0-.315.183.822.822,0,0,0-.207.271.711.711,0,0,0-.067.331l.047,1.48A.718.718,0,0,0,38.429,61.1Z",
    transform: "translate(-2.267 -10.381)",
    fill: "#07a3c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10653",
    "data-name": "Path 10653",
    d: "M34.422,10.14H20.273c-2.31,0-4.183.956-4.183,2.135v4.612H61.121v-1.45c0-1.179-1.873-2.135-4.183-2.135H38.606V12.285c.005-.568-.433-1.114-1.218-1.516A6.694,6.694,0,0,0,34.422,10.14Z",
    transform: "translate(4 14.08)",
    fill: "#07a3c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10654",
    "data-name": "Path 10654",
    d: "M5.982,41.1,9.019,65.6a4.164,4.164,0,0,0,4.106,3.658H51.6A4.164,4.164,0,0,0,55.708,65.6l3.1-24.5a3.555,3.555,0,0,0-.84-2.767,3.441,3.441,0,0,0-2.6-1.19H9.445A3.44,3.44,0,0,0,6.83,38.32,3.554,3.554,0,0,0,5.982,41.1Zm14.766,8.889a10.838,10.838,0,0,1,2.569-3.658,12.534,12.534,0,0,1,4.028-2.53,14,14,0,0,1,10.1,0,12.54,12.54,0,0,1,4.028,2.53,10.839,10.839,0,0,1,2.569,3.658,9.723,9.723,0,0,1,.756,4.329,9.868,9.868,0,0,1-1.2,4.17,11.145,11.145,0,0,1-2.737,3.292A12.765,12.765,0,0,1,37,63.941a14.03,14.03,0,0,1-9.244,0,12.759,12.759,0,0,1-3.86-2.164,11.146,11.146,0,0,1-2.737-3.292,9.868,9.868,0,0,1-1.2-4.17A9.716,9.716,0,0,1,20.748,49.986Z",
    transform: "translate(10 -4.824)",
    fill: "#07a3c8"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLabs2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/labs2.39e6f6f5.svg";
export { ForwardRef as ReactComponent };